<div class="filters">
  <app-switch-checkbox
    *ngFor="let filter of filtersOptions; trackBy: trackByFilters"
    [checked]="filter.enabled"
    (change)="change(filter.id, $event)"
    >{{ filter.name }}</app-switch-checkbox
  >
</div>
